//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    particlesStatus: {
      type: Boolean,
      default: true
    }
  },
  name: "Particles",
};
